import React, { memo } from "react";
import DataTable from "react-data-table-component";
import type { TableProps as DataTableProps } from "react-data-table-component";
import Pagination from "./Pagination";
import styles from "./Table.module.scss";
import { combineClasses } from "@/lib/utils";
import TableSkeleton from "./TableSkeleton";
import { useSelector } from "react-redux";
import EmptyState from "@/components/EmptyState/EmptyState";

// Custom props that are NOT part of react-data-table's TableProps
interface CustomTableProps {
  className?: string | undefined;
  containerClassName?: string | undefined;
  paginationProps?: {
    isPagination: boolean;
    [key: string]: any; // You can refine this as needed
  };
}

// Combine DataTable's props with custom ones
type Props<T> = DataTableProps<T> & CustomTableProps;

const Table = <T,>(props: Props<T>) => {
  const { sidebarOpen } = useSelector((state: any) => state.global);

  return (
    <div
      className={combineClasses(
        styles.tableCard,
        sidebarOpen ? styles.sidebarOpen : "",
        props.containerClassName || ""
      )}
    >
      <div className={styles.tableScroll}>
        <DataTable
          {...props}
          pagination={false}
          noDataComponent={<EmptyState message="There are no records to display" />}
          columns={props?.columns}
          className={combineClasses(
            "scrollable",
            styles.table,
            props.className || ""
          )}
          progressComponent={
            <TableSkeleton
              columns={props?.columns || []}
              sidebarOpen={sidebarOpen}
            />
          }
          persistTableHead
          fixedHeader={true}
          fixedHeaderScrollHeight={
            (props as any).fixedHeaderScrollHeight || "calc(100vh - 14rem)"
          }
          responsive
        />
      </div>

      {props?.paginationProps?.isPagination && (
        <Pagination {...props?.paginationProps} />
      )}
    </div>
  );
};

export default memo(Table) as typeof Table;
